<template>
  <div>

    <div v-show="errorMessage.length > 0">
        <div class="text-red-600">
            {{ errorMessage }}
        </div>
        <hr/>
        <router-link :to="{ name: 'database_connections' }" style="color:red;">
            Essayez de connecter votre compte Google à nouveau.
        </router-link>
    </div>

    <div v-show="promisePending && errorMessage.length === 0" class=" absolute top-0 right-0 animate-spin text-center flex justify-center items-center">
      <i class=" fas fa-spinner w-6 h-6"></i>
    </div>

    <!-- credential name -->
    <div v-if="googleAccounts.length > 0">
      <!-- nom du credential airtable -->
      <label for="google_credential">Compte Google</label>
      <b-form-select
          id="google_credential"
          v-model="export_info.credentialName" :options="googleAccounts"
          class="mb-2">
      </b-form-select>
    </div>

    <div>
      <b-form-checkbox
          v-model="export_info.createSheetMode"
          class="mb-2" switch>
          Nouvelle feuille
      </b-form-checkbox>
    </div>

    <!-- Name of target file column/value -->
    <div v-show="export_info.createSheetMode">
      <label for="new_sheet_name">Nom de la nouvelle feuille</label>
      <input
          id="new_sheet_name"
          class="rounded-md p-1 w-full leading-relaxed mb-2"
          v-model="export_info.targetFileName"
          placeholder="Nom de la nouvelle feuille"/>
      <hr/>
    </div>

    <!-- Autocomplete if you want to update a file -->
    <div v-show="!export_info.createSheetMode">
      <google_drive_autocomplete
          :credentialName="export_info.credentialName"
          :searchMeta="'application/vnd.google-apps.spreadsheet'"

          :initial-id="export_info.targetFileName"

          @SelectedFile="(selectedFile) => fileSelected(selectedFile)"
          class="mb-2"
          >
      </google_drive_autocomplete>

      <google_sheet_selector
          v-if="selectedFileVal !== null"
          :credentialName="export_info.credentialName"
          :spreadsheetId="selectedFileVal.value"

          @updateRange="(range) => export_info.targetRange = range"
          class="mb-2"
          >
      </google_sheet_selector>

      <hr/>
    </div>

  </div>

</template>

<script setup>
import { defineProps, onMounted, ref, watch } from 'vue';
import store from '../../store';
import google_service from "../../services/google.js";
var clone = require("clone");
import google_drive_autocomplete from '../connection_modals/google_drive_autocomplete.vue';
import google_sheet_selector from '../connection_modals/google_sheet_selector.vue';

const props = defineProps({
  editorRef: Object,
  availableColumns: Array,
  initialValue: Object,
  prevData: Array,
});

const errorMessage = ref("");
const promisePending = ref(false);

const googleAccounts = ref([]);

const selectedFileVal = ref(null);

const export_info = ref({
  credentialName: props.initialValue.body_params.credentialName ? props.initialValue.body_params.credentialName :  "",

  targetFileName: props.initialValue.body_params.targetFileName ? props.initialValue.body_params.targetFileName :  "",
  targetRange: props.initialValue.body_params.targetRange ? props.initialValue.body_params.targetRange :  "",

  createSheetMode: props.initialValue.body_params.createSheetMode !== undefined ? props.initialValue.body_params.createSheetMode : true,
});

const fileSelected = (selectedFile) => {
  console.log("Selected file: ", selectedFile);
  selectedFileVal.value = selectedFile;
  export_info.value.targetFileName = selectedFile.value;
}

const loadAccounts = async () => {
    // loadspinner
    errorMessage.value = "";
    promisePending.value = true;

    let accounts = await google_service.getAccounts()
                        .catch((err) => {
                            console.log("Error getting accounts: ", err);
                        });

    console.log("Got accounts: ", accounts);
    if (!accounts) {
        errorMessage.value = "Erreur lors de la récupération des comptes google.";
        promisePending.value = false;
        return;
    }
    accounts = accounts.googleAccounts;

    googleAccounts.value = accounts.map((account) => {
        return {
            value: account.name,
            text: account.name
        }
    });

    export_info.value.credentialName = googleAccounts.value[0].value;

    promisePending.value = false;
}

watch(export_info, (newVal) => {
    // console.log("New export info: ", newVal);

  let schema = clone(props.initialValue);

  let saas_back_uri = process.env.VUE_APP_SAAS_BACK;

  schema.uri = `${saas_back_uri}/google/spreadsheet/raw`;
  schema.method = export_info.value.createSheetMode ? "post" : "put";

  schema.headers_params = {
      'Authorization': `Bearer ${store.state.jwt}`,
      'Content-type': 'application/json'
  };

  schema.unique = true;

  schema.sleep = 200;

  // send the data in the body

  schema.body_params = {
      "credentialName": newVal.credentialName,
      "targetFileName": newVal.targetFileName,
      "targetRange": newVal.targetRange,
      "values": props.prevData,
      "credentialDecrypted": true
  };

  delete schema.body;
  delete schema.form;
  delete schema.formData;
  delete schema.form_data_params;
  delete schema.form_params;
  delete schema.qs;
  delete schema.qs_params;
  console.log("schema: ", clone(schema));

  props.editorRef.setValue(schema);
},
{ deep: true }
);


onMounted(() => {
  
  // * on attend que le json editor se charge
  setTimeout(async () => {
      var startingValue = props.editorRef.getValue();
      console.log("Loading google sheets with: ", clone(startingValue));

      // extract file name from body or body_params
      export_info.value.credentialName = startingValue.body_params.credentialName ? startingValue.body_params.credentialName : "";
      export_info.value.targetFileName = startingValue.body_params.targetFileName ? startingValue.body_params.targetFileName : "";
      export_info.value.targetRange = startingValue.body_params.targetRange ? startingValue.body_params.targetRange : "";

      export_info.value.createSheetMode = startingValue.method === "post" ? true : false;

      // if (initialURL) {
      //     // let appId = initialURL.match(/app\w+/g)[0];
      //     let tableId = initialURL.match(/tbl\w+/g)[0];
      //     this.currentRequest.tableId = tableId ? tableId : "";
      // }

      await loadAccounts();

  }, 1);
});

</script>